<template>
  <div class="kpt-portal-main" :class="{ 'kpt-portal-main-collapsed': menuCollapsed }">
    <navigation></navigation>
    <div class="kpt-portal-content">
      <router-view></router-view>
    </div>
    <transition name="slide-wide">
      <detail-pane v-show="detailPaneVisible"></detail-pane>
    </transition>
    <transition name="slide-narrow">
      <context-pane v-show="contextPaneVisible"></context-pane>
    </transition>
  </div>
</template>
<script>
import PortalNavigation from './PortalNavigation.vue';
import ContextPane from './ContextPane.vue';
import DetailPane from './DetailPane.vue';

export default {
  watch: {
    // eslint-disable-next-line quote-props, no-unused-vars
    '$route': function (newRoute, oldRoute) {
      // if (newRoute.params.id || newRoute.path.includes('create')) {
      if (newRoute.params.id || newRoute.meta.detail) {
        this.$store.commit('setDetailPane', true)
      } else {
        this.$store.commit('setDetailPane', false)
      }
    }
  },
  components: {
    // eslint-disable-next-line quote-props
    'navigation': PortalNavigation,
    'context-pane': ContextPane,
    'detail-pane': DetailPane
  },
  computed: {
    contextPaneVisible() {
      return this.$store.state.system.contextPane != null;
    },
    detailPaneVisible() {
      return this.$store.state.system.detailPane;
    },
    menuCollapsed() {
      return this.$store.state.user.settings.menuCollapsed;
    }
  },
  mounted() {
    const existingRoute = this.$route;
    if (existingRoute.params.id || existingRoute.path.includes('/create')) {
      this.$store.commit('setDetailPane', true);
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-portal-main {
  position: relative;
  display: flex;
  align-items: stretch;
  height: calc(100% - 60px);
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;

  .kpt-portal-content {
    overflow-y: auto;
    flex: 1 1 auto;
    width: calc(100% - 190px);
     overflow-x:hidden
    }
  
  .slide-wide-enter, .slide-wide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateX(calc(100% - 315px));
  }

  .slide-narrow-enter, .slide-narrow-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateX(315px);
  }
}

.kpt-portal-main-collapsed {
  .kpt-portal-content {
    width: calc(100% - 52px);
  }
}
</style>
